import { useState, useEffect } from 'react';
import styles from './nav-header.module.css';
import logo from '../../images/logo.png';

const NavHeader = () => {
    const [isActive, setIsActive] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeLink, setActiveLink] = useState('/');

    const toggleNavbar = () => {
        setIsActive(!isActive);
    };

    const closeNavbar = () => {
        setIsActive(false);
    };

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset;
            setIsScrolled(scrollTop > 50);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle active link
    useEffect(() => {
        setActiveLink(window.location.pathname);
    }, []);

    const handleLinkClick = (href) => {
        setActiveLink(href);
        closeNavbar();
    };

    const navItems = [
        { href: '/guest/', label: 'Home' },
        { href: '/guest/project-networks', label: 'Projects' },
        { href: '/guest/social', label: 'Social' },
        { href: '/guest/learn-teach', label: 'Learn/Teach' },
        // { href: '/guest/applied-interns', label: 'Applied' },
        // { href: '/guest/recruiter-messages', label: 'Recruiters' },
        // { href: '/guest/messages', label: 'Messages' }, // Optional notification badge
        // { href: '/guest/messages', label: 'Messages', badge: '3' }, // Optional notification badge
        // { href: '/guest/profile', label: 'Profile' },
        // { href: '/guest/settings', label: 'Settings' },
        { href: '/login', label: 'Login' }
    ];

    return (
        <nav className={`${styles.navbar} ${isActive ? styles.navbarActive : ''} ${isScrolled ? styles.scrolled : ''}`}>
            <div onClick={() => window.location.href = '/'} className={styles.logoContainer}>
                <img className={styles.logo} src={logo} alt="Logo" />
                <div className={styles.navbarLogo}>MERILITE</div>
            </div>
            
            <ul className={styles.navbarLinks}>
                {navItems.map((item, index) => (
                    <li key={index}>
                        <a 
                            href={item.href}
                            className={activeLink === item.href ? styles.active : ''}
                            onClick={() => handleLinkClick(item.href)}
                            data-badge={item.badge}
                        >
                            {item.label}
                        </a>
                    </li>
                ))}
            </ul>
            
            <button 
                className={styles.navbarToggle} 
                onClick={toggleNavbar}
                aria-label="Toggle navigation menu"
                aria-expanded={isActive}
            >
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
                <span className={styles.bar}></span>
            </button>
        </nav>
    );
};

export default NavHeader;